import axios from 'axios';

export const fetchAllAdminPages = async (url, params = {}) => {
  const items = [];
  let page = 1;
  let pages = 1;
  do {
    const response = await axios.get(url, { params: { ...params, page, limit: 100 }, withCredentials: true });
    items.push(...response.data.items);
    pages = response.data.pages;
    page += 1;
  } while (page <= pages);
  return items;
};
